//Create a roster for each team.
//Even while not logged in, you can see a list of players within the chosen team.
//This here is a page that OUTPUTS that list.
import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Players.css'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Footer from '../../shared/components/UIElements/Footer'
//import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import RosterAndScheduleHome from '../../shared/components/Navigation/RosterAndScheduleHome'
//
import Arsenal from '../../images/Arsenal.png'
import BarrieKingsmen from '../../images/Barrie-kingsmen.png'
import ChicagoSouthsiders from '../../images/Chicago Southsiders.png'
import Dekheads from '../../images/Dekheads.png'
import Gods from '../../images/Gods.png'
import Graffix from '../../images/Graffix.png'
import Indians from '../../images/Indians.png'
import MidnightExpress from '../../images/Midnight Express.png'
import NightsWatch from '../../images/Nights Watch.png'
import NorthsideMilitia from '../../images/Northside Militia.png'
import PurplePower from '../../images/Purple Power.png'
import RoseCityRoyals from '../../images/Rose City Royals.png'
import Warriors from '../../images/Warriors.png'
import USA from '../../images/USA-logo.png'
import JrGods from '../../images/Team Pittsburgh Jr. Gods.png'
import Raptors from '../../images/Riverview Raptors.jpeg'
import Americans from '../../images/Americans.png'

const RosterAndSchedulePage = () => {
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [rosteredPlayers, setRosteredPlayers] = useState()
	const [gamesList, setGamesList] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [leagueName, setLeagueName] = useState()
	const [teamId, setTeamId] = useState()
	const [headCoach, setHeadCoach] = useState()
	const [assistantCoaches, setAssistantCoaches] = useState()
	const [generalManager, setGeneralManager] = useState()
	const [assistantGeneralManagers, setAssistantGeneralManagers] = useState()
	const [photo, setPhoto] = useState()
	//
	const leagueId = useParams().leagueId
	const divisionName = useParams().divisionName
	const year = useParams().year
	const teamName = useParams().teamName

	const teamLogoMap = {
		'Penn Hills Arsenal': Arsenal,
		'Barrie Kingsmen': BarrieKingsmen,
		'Chicago Southsiders': ChicagoSouthsiders,
		'Iowa Dekheads': Dekheads,
		'Pittsburgh Gods': Gods,
		'Graffix Ball Hockey Club': Graffix,
		'Garden State Indians': Indians,
		'Brampton Midnight Express': MidnightExpress,
		"South Jersey Night's Watch": NightsWatch,
		'South Jersey Night’s Watch': NightsWatch,
		'Northside Militia': NorthsideMilitia,
		'Pittsburgh Purple Power': PurplePower,
		'Rose City Royals': RoseCityRoyals,
		'Garden State Warriors': Warriors,
		'USA Legends': USA,
		'Leominster Americans': Americans,
		'Pittsburgh Jr. Gods': JrGods,
		'Riverview Raptors': Raptors,
	}

	const teamLogo = teamLogoMap[teamName]

	console.log('inside RosterAndSchedulePage ')

	//taps into LEAGUE backend, getPlayersOnTeam. There's also getPlayersOnTeam in admin backend, so be careful
	//Also returns wins, losses, OTlosses, and SOlosses
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/${leagueId}/${divisionName}/${year}/${teamName}`,
				)

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}
				setRosteredPlayers(responseData.rosteredPlayers)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setPhoto(responseData.photo)
				setLeagueName(responseData.leagueName)
				setHeadCoach(responseData.headCoach)
				setAssistantCoaches(responseData.assistantCoaches)
				setGeneralManager(responseData.generalManager)
				setAssistantGeneralManagers(responseData.assistantGeneralManagers)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [divisionName, teamName, year, leagueId])
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//Send a request to get all the games for this team to display a schedule
	//leagueController - getTeamSchedule
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/schedule/${leagueId}/${divisionName}/${year}/${teamName}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					console.log('whoopsie daisy')
					throw new Error(responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))

				setGamesList(responseData.allGamesArray)

				setTeamId(responseData.teamId)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [divisionName, teamName, year, leagueId])

	gamesList && console.log('gamesList: ' + JSON.stringify(gamesList))

	const isMobile = window.innerWidth <= 440

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				{/* <StatsAndStandingsHome /> */}
				<RosterAndScheduleHome />
				{/* {teamLogo && (
					<div className='teamLogoContainer'>
						<img src={teamLogo} alt={`${teamName} logo`} className='teamLogo' />
					</div>
				)}
				{!teamLogo && <div style={{ marginTop: '5rem' }}></div>} */}
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && rosteredPlayers && gamesList && (
					<React.Fragment>
						<div
							className='Roster'
							style={{
								marginTop: isMobile ? '.5rem' : undefined,
							}}
						>
							<div className='rosterHeroCard'>
								{teamLogo && (
									<img
										src={teamLogo}
										alt={`${teamName} logo`}
										className='rosterHeroLogo'
									/>
								)}

								<h1>{teamName}</h1>

								<div className='rosterHeroTitle'>
									<span></span>
									ROSTER
									<span></span>
								</div>

								<div className='rosterHeroPill'>{divisionName} Division</div>
								<p>Click on a player name to see their player page</p>
							</div>
							{photo && (
								<div className='photoDiv'>
									<img
										src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
										//style={{ width: '9%' }}
										className='teamPhoto'
									/>
								</div>
							)}
							{headCoach && (
								<p style={{ textAlign: 'center' }}>Head Coach: {headCoach}</p>
							)}
							{assistantCoaches && (
								<p style={{ textAlign: 'center' }}>
									Assistant Coach(es): {assistantCoaches}
								</p>
							)}
							{generalManager && (
								<p style={{ textAlign: 'center' }}>
									General Manager: {generalManager}
								</p>
							)}
							{assistantGeneralManagers && (
								<p style={{ textAlign: 'center' }}>
									Assistant General Manager(s): {assistantGeneralManagers}
								</p>
							)}

							<h3 className='h3Center'>
								Record: {wins} - {losses} -{' '}
								{ties + overtimeLosses + shootoutLosses}
							</h3>

							<p style={{ textAlign: 'center', fontSize: 'xx-small' }}>
								(GWG: Game-Winning Goal)
							</p>
							<table id='roster'>
								<thead>
									<tr>
										{/* <th>Number</th> */}
										<th>Name</th>
										<th>G</th>
										<th>A</th>
										{/* <th>PG</th>
										<th>PA</th> */}
										<th>GWG</th>
										<th>Total Pts.</th>
										<th>PIM</th>
									</tr>
								</thead>
								<tbody>
									{rosteredPlayers.map((player, key) => {
										{
											return (
												<tr key={key}>
													{/* <td>{player.number}</td> */}
													<td className='tableDataTeamName'>
														<Link
															style={{
																textDecoration: 'none',
																color: 'black',
																fontWeight: 600,
															}}
															to={`/${player.playerId}/history`}
														>
															{player.firstName} {player.lastName}{' '}
															{player.isCaptain && '(Captain)'}{' '}
															{player.isGoalie && '(G)'}
														</Link>
														{' ('}
														{player.number}
														{')'}
													</td>
													<td>{player.goals + player.playoffGoals}</td>
													<td>{player.assists + player.playoffAssists}</td>
													{/* <td>{player.playoffGoals}</td>
													<td>{player.playoffAssists}</td> */}
													<td>{player.gwg}</td>
													<td>
														{player.goals +
															player.assists +
															player.playoffGoals +
															player.playoffAssists}
													</td>
													<td>{player.pim}</td>
												</tr>
											)
										}
									})}
								</tbody>
							</table>
						</div>
						{/* THIS STARTS THE TEAMS SCHEDULE */}
						{/* <div className='Roster'>
							<h1>Schedule:</h1>
							<p className='clickOn' style={{ textAlign: 'center' }}>
								(Click on the final score of a game to see a Game Summary)
							</p>
							<p className='clickOn' style={{ textAlign: 'center' }}>
								(Click on an Opponent's team name to go to their roster and
								schedule page)
							</p>
							<table id='teamSchedule'>
								<thead>
									<tr>
										<th>Date/Time</th>
										<th>Opponent</th>
										<th>Score</th>
										<th>Pts</th>
										<th>Venue</th>
									</tr>
								</thead>
								<tbody>
									{gamesList.map((game, key) => {
										{
											return (
												<tr key={key}>
													<td>
														{game.dayOfWeek}
														{', '}
														{game.date.substr(0, 2) === '01' &&
															'Jan ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '02' &&
															'Feb ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '03' &&
															'Mar ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '04' &&
															'Apr ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '05' &&
															'May ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '06' &&
															'June ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '07' &&
															'July ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '08' &&
															'Aug ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '09' &&
															'Sept ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '10' &&
															'Oct ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '11' &&
															'Nov ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '12' &&
															'Dec ' + game.date.substr(3, 2)}
														<br></br>
														{game.time.substr(0, 2) === '00' &&
															'12:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '01' &&
															'1:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '02' &&
															'2:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '03' &&
															'3:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '04' &&
															'4:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '05' &&
															'5:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '06' &&
															'6:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '07' &&
															'7:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '08' &&
															'8:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '09' &&
															'9:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '10' &&
															'10:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '11' &&
															'11:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '12' &&
															'12:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '13' &&
															'1:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '14' &&
															'2:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '15' &&
															'3:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '16' &&
															'4:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '17' &&
															'5:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '18' &&
															'6:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '19' &&
															'7:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '20' &&
															'8:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '21' &&
															'9:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '22' &&
															'10:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '23' &&
															'11:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '24' &&
															'12:' + game.time.substr(3, 2) + ' am'}
													</td>
													{game.homeTeamName === teamName && (
														<td>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'black',
																}}
																to={`/league/${leagueId}/${divisionName}/${year}/${game.visitorTeamName}`}
															>
																{game.visitorTeamName}
															</Link>
															{game.description && (
																<div
																	style={{ color: 'red', fontWeight: 'bold' }}
																>
																	{'('}
																	{game.description}
																	{')'}
																</div>
															)}
														</td>
													)}
													{game.visitorTeamName === teamName && (
														<td>
															@{' '}
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'black',
																}}
																to={`/league/${leagueId}/${divisionName}/${year}/${game.homeTeamName}`}
															>
																{game.homeTeamName}
															</Link>
															{game.description && (
																<div
																	style={{ color: 'red', fontWeight: 'bold' }}
																>
																	{'('}
																	{game.description}
																	{')'}
																</div>
															)}
														</td>
													)}
													{!game.score && <td></td>}
													{game.score && !game.winner && !game.loser && (
														<td style={{ color: 'black', fontWeight: 'bold' }}>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'black',
																}}
																to={`/gameSummary/${game._id}`}
															>
																TIED {game.score}
															</Link>
														</td>
													)}
													{game.loser === teamId && (
														<td style={{ color: 'red', fontWeight: 'bold' }}>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'red',
																}}
																to={`/gameSummary/${game._id}`}
															>
																LOST {game.score}{' '}
																<span
																	style={{ color: 'black', fontWeight: 'bold' }}
																>
																	{game.scoreSuffix}
																</span>
															</Link>
														</td>
													)}
													{game.winner === teamId && (
														<td style={{ color: 'green', fontWeight: 'bold' }}>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'green',
																}}
																to={`/gameSummary/${game._id}`}
															>
																WON {game.score}{' '}
																<span
																	style={{ color: 'black', fontWeight: 'bold' }}
																>
																	{game.scoreSuffix}
																</span>
															</Link>
														</td>
													)}
													<td style={{ fontWeight: 'bold' }}>
														{!game.score && ''}
														{game.score &&
															game.homeTeamName === teamName &&
															game.homePointsAwarded}
														{game.score &&
															game.visitorTeamName === teamName &&
															game.visitorPointsAwarded}
													</td>
													<td>{game.venueName}</td>
												</tr>
											)
										}
									})}
								</tbody>
							</table>
						</div> */}
						<Footer />
					</React.Fragment>
				)}
			</React.Fragment>
		</div>
	)
}

export default RosterAndSchedulePage
